(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('custactComps', {
        templateUrl: 'views/components/views/custactComps/custactComps.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'custactCompsService', 'economyService', function ($stateParams, stateService, utilityService, custactCompsService, economyService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let custactNo = $stateParams.custact_no;

            vm.model = {
                bgCustactCompListSelection: {
                    selected: 'S',
                    buttons: [
                        { id: 'S', label: 'custactcomps_selected', color: 'primary', onClick: () => vm.model.bgCustactCompListSelection.selected = 'S' },
                        { id: 'A', label: 'custactcomps_all', color: 'primary', onClick: () => vm.model.bgCustactCompListSelection.selected = 'A' }
                    ]
                },
                menu: {},
                itemsListComponents: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadMenu() {
                vm.model.menu = (await economyService.getCustomerActivity({ custact_no: custactNo }))[0];

                loadComponents();
            }

            async function loadComponents() {
                if (utilityService.validateParmsValue(vm.model.menu.custact_no) !== true) return;

                vm.model.itemsListComponents = (await custactCompsService.listComponents({
                    custact_no: vm.model.menu.custact_no,
                    select_status: vm.model.bgCustactCompListSelection.selected
                }));
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region VALIDATION FUNCTION
            
            vm.validateCheckItem = function (item) {
                if (item.item_is_selected == '1') {
                    item.item_is_selected = '0';
                    item.item_glyphicon_color = 'black';
                    item.item_glyphicon = 'glyphicon-unchecked';
                } else {
                    item.item_is_selected = '1';
                    item.item_glyphicon_color = 'green';
                    item.item_glyphicon = 'glyphicon-check';
                }

                custactCompsService.saveP2CustactCompIsSelected(item).then(function (item) {
                    
                });
            };

            // #endregion VALIDATION FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgCustactCompListSelection = function (value) {
                vm.model.bgCustactCompListSelection.selected = value;
                loadComponents();
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'custactcomp':
                        go({
                            custact_no: vm.model.menu.custact_no,
                            custactcomp_keyno: '0'
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadMenu();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
